export function courtHireCheckoutSessionKey(clubSlug: string): string {
  return `court-hire-checkout:${clubSlug}`;
}

export function hasActiveCourtHireCheckoutSession(clubSlug: string): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  try {
    const raw = sessionStorage.getItem(courtHireCheckoutSessionKey(clubSlug));
    if (!raw) return false;
    const session = JSON.parse(raw) as { pendingPayment?: { clientSecret?: string } };
    return Boolean(session.pendingPayment?.clientSecret);
  } catch {
    return false;
  }
}
